<template>
    <div class="assign_mgmt_page">
        <div class="assign_header">
            <div class="header_title">{{ card_name }}</div>
            <div class="header_subtitle">加油卡分配管理</div>
        </div>
        <div class="assign_scroll_area">
            <loadmore @loadmore="getList" :loading="loading" :isloading="isloading" :noMone="noMone">
                <div class="assign_list"> 
                    <div class="assign_card" v-for="item in data">
                        <div class="assign_info">
                            <span class="assign_category">{{ item.category }}</span>
                            <span class="assign_time">{{ item.created_at }}</span>
                        </div>
                        <div class="assign_value">
                            <span class="amount">{{ item.money }}</span>
                            <small>升</small>
                        </div>
                    </div>
                </div>
            </loadmore>
        </div>
    </div>
</template>

<script>
import common from "../common";
import loadmore from "../public/loadmore";
export default {
name: 'assignationManagement',
    data () {
        return {
            data: [],
            pageVal: "0",
            pageSize: "10",
            account_id:"",
            card_name:"",
            loading: false, //为true时不会触发加载更多，false可以触发
            isloading:true,//显示加载中
            noMone: false,//是否没有更多
            token:""
        }
    },
    mounted() {
        this.card_name=JSON.parse(this.$router.currentRoute.params.card_obj).card_name;
        this.account_id=JSON.parse(this.$router.currentRoute.params.card_obj).id;
        //判断cookie中是否存在token
        let ifcookietoken=document.cookie.indexOf("token=")!=-1;
        if(!!JSON.parse(common.getlocalStorage("userInfo"))){
            this.token=JSON.parse(common.getlocalStorage("userInfo")).token;
        } else if(ifcookietoken){
            this.token=common.getCookie("token");
        }else{
            this.$router.replace({ name: 'login'});
        }
    },
    methods: {
        //获取列表
        getList (a) {
            let token=this.token;
            let querystring = require('querystring');
            this.isloading=true;
            this.$api.post('wx/shareList',
                querystring.stringify({
                    account_id:this.account_id,
                    pageSize:this.pageSize,
                    pageNum:a,
                    token:token
                })
            ).then(data=>{
                if(a<data.data.pageTotal){
                    for(var i=0; i<this.pageSize; i++){
                        this.data.push(data.data.data[i]);
                    }
                    this.loading = false;
                }else if(a==data.data.pageTotal){
                    for(var i=0; i<data.data.data.length; i++){
                        this.data.push(data.data.data[i]);
                    }
                    this.loading = false;
                }else{
                    this.loading = true;
                    this.noMone=true;
                }
                this.isloading=false;
            }).catch(err=>{
                console.log(err);
            })
        }
    },
    created() {
        // if(!common.getlocalStorage("userInfo")){
        //     this.$router.replace({ name: 'login'});
        // }
    },
    components:{
        loadmore
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.assign_mgmt_page {
    width: 100vw;
    height: 100vh;
    background-color: #f6f8fa;
    display: flex;
    flex-direction: column;
}

.assign_header {
    background: linear-gradient(135deg, #106EBE 0%, #005a9e 100%);
    padding: 30px 20px;
    color: white;
    text-align: center;
    box-shadow: 0 4px 10px rgba(16, 110, 190, 0.1);
}

.header_title {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 4px;
}

.header_subtitle {
    font-size: 13px;
    opacity: 0.8;
}

.assign_scroll_area {
    flex: 1;
    overflow-y: auto;
}

.assign_list {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.assign_card {
    background: white;
    border-radius: 12px;
    padding: 16px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
}

.assign_info {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.assign_category {
    font-size: 15px;
    font-weight: 600;
    color: #333;
}

.assign_time {
    font-size: 12px;
    color: #adb5bd;
}

.assign_value {
    display: flex;
    align-items: baseline;
    gap: 2px;
    color: #106EBE;
}

.assign_value .amount {
    font-size: 20px;
    font-weight: 700;
}

.assign_value small {
    font-size: 12px;
    font-weight: 600;
}
</style>
      


// WEBPACK FOOTER //
// src/components/assignationManagement.vue